const {KitModule, registerModule} = window;

class Event extends KitModule {
  constructor($element) {
    super($element);

    this.updateUI = this.updateUI.bind(this);
    this.udpateCountdown = this.udpateCountdown.bind(this);

    this.setVars();
    // this.renderLocalTime();
    this.checkEventIsPast();
    this.udpateCountdown();
    this.timeoutId = setInterval(this.udpateCountdown, 1000);
  }

  setVars() {
    const startDate = parseInt(this.$element.getAttribute('data-start-date'));
    if (startDate && !isNaN(startDate)) {
      this.date = new Date(startDate);
    }

    this.metas = {
      isPast: false,
      timer: null,
    };
  }

  checkEventIsPast() {
    if (this.now > this.eventDate) {
      this.metas.isPast = true;
      clearInterval(this.timeoutId);
    }
  }

  renderLocalTime() {
    const dateString = this.date?.toLocaleString(undefined, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });

    const timeString = this.date?.toLocaleString(undefined, {
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    });

    if (this.$eventDate) {
      // $eventDate is only rendered if the event is upcoming
      if (dateString && timeString) {
        this.$eventDate.innerText = `${dateString} ${timeString}`;
      }

      this.$eventDate.dataset.jsVisible = true;
    }
  }

  udpateCountdown() {
    const future = Date.parse(this.date);
    const now = new Date();
    const diff = future - now;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const mins = Math.floor(diff / (1000 * 60));
    const secs = Math.floor(diff / 1000);

    const d = days;
    const h = hours - days * 24;
    const m = mins - hours * 60;
    const s = secs - mins * 60;

    this.metas.timer = {d, h, m, s};
    this.updateUI();
  }

  updateUI() {
    this.output = `
        <p class="postWithForm-countdown__d">
            <span class="type-ui-1">
                ${this.metas.timer.d}
            </span>
            <span class="type-eyebrow-3">${this.metas.timer.d === 1 ? 'Day' : 'Days'}</span>
        </p>
        <p class="postWithForm-countdown__h">
            <span class="type-ui-1">
                ${this.metas.timer.h}
            </span>
            <span class="type-eyebrow-3">${this.metas.timer.h === 1 ? 'Hour' : 'Hours'}</span>
        </p>
        <p class="postWithForm-countdown__m">
            <span class="type-ui-1">
                ${this.metas.timer.m}
            </span>
            <span class="type-eyebrow-3">${this.metas.timer.m === 1 ? 'Minute' : 'Minutes'}</span>
        </p>
        <p class="postWithForm-countdown__s">
            <span class="type-ui-1">
                ${this.metas.timer.s}
            </span>
            <span class="type-eyebrow-3">${this.metas.timer.s === 1 ? 'Second' : 'Seconds'}</span>
        </p>
      `;

    if (this.$countdown) {
      // $countdown is only rendered if the event is upcoming
      this.$countdown.innerHTML = this.output;
    }
  }
}

registerModule('Event', Event);
